import React, { useState, useEffect } from 'react';
import { DateTime } from 'luxon';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import { DialogContentText } from '@material-ui/core';
import Button from '../../components/Button';
import { withRouter } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core/styles';
import { withSnackbar } from 'notistack';
import { isEmpty } from 'lodash';
import AppointmentContext from '../../contexts/AppointmentContext';
import { CurrentUserConsumer } from '../../contexts/CurrentUserContext';
import PatientInformationForm from './components/PatientInformationForm';
import VisitInformation from '../../components/VisitInformation';
// import socketIoClient from '../../socket/socketConfig';
import queryString from 'query-string';
import {
  fetchProvider,
  bookAppointment,
  fetchPatientById,
  overBookedAppt,
} from '../../services/api';
import * as searchApi from '../../services/api/search';
import * as authApi from '../../services/api/auth';
import * as adminApi from '../../services/api/admin';
import { createAppointmentRequest } from '../../services/api';

function SearchCheckout(props) {
  const {
    history,
    location,
    enqueueSnackbar,
    context,
    classes: {
      container,
      containerForm,
      currentPatientNotice,
      link,
      visitInfo,
      button,
      btnCenter
    },
  } = props;

  const [provider, setProvider] = useState({});
  const [tenancy, setTenancy] = useState({});
  const [appointmentStart, setAppointmentStart] = useState('');
  const [isAptRequest, setIsAptRequest] = useState(false);
  const [showProviderRestrictedModal, setShowProviderRestrictedModal] =
    useState(false);
  const [showPatientRestrictPopUp, setShowPatientRestrictPopUp] =
    useState(false);
  const [providerFamily, setProviderFamily] = useState('');
  const [images, setImages] = useState([]);
  const [imageFront, setImageFront] = useState([]);
  const [imageBack, setImageBack] = useState([]);
  const [getCurrentUser, setGetCurrentUser] = useState({});
  const [changeCurrentPatient, setChangeCurrentPatient] = useState({});
  const [open, setOpen] = useState(false);
  // const [dupliacteApptAlert, setOpenDuplicateApptAlert] = useState(false);

  useEffect(() => {
    (async () => {
      window.scrollTo(0, 0);
      const values = queryString.parse(location.search);
      if (!isEmpty(values)) {
        if (values.patientId !== 'undefined') {
          const setPatientVal = await fetchPatientById(values.patientId);
          setChangeCurrentPatient(setPatientVal);
        }

        if ('aptRequest' in values) {
          setIsAptRequest(true);
          const provider = await fetchProvider(values.providerId);
          setProvider(provider);
          return;
        } else {
          return setStateFromUrlParams(values);
        }
      }

      const { provider, start, tenancy } = context;

      if (!provider || !start || !tenancy) {
        history.push('/search');
        return;
      }

      setProvider(provider);
      setTenancy(tenancy);
      setAppointmentStart(start);
    })();
  }, []);

  const setStateFromUrlParams = async (values) => {
    const { providerId, tenancyId, start } = values;
    const provider = await fetchProvider(providerId);
    let tenancy = await searchApi.fetchTenancy(tenancyId);
    context.updateAppointment({ provider, tenancy, start });

    setProvider(provider);
    setTenancy(tenancy);
    setAppointmentStart(start);
  };

  const onSubmit = async (patientInfo) => {
    patientInfo.attachments = images.map((i) => i.dataUrl);
    patientInfo.insuranceFile =
      imageFront &&
      imageFront
        .map((i) => i.dataUrl)
        .concat(imageBack && imageBack.map((i) => i.dataUrl));
    if (isAptRequest) {
      try {
        const params = {
          providerId: provider.id,
          patientFirstName: patientInfo.firstName,
          patientLastName: patientInfo.lastName,
          patientEmail: patientInfo.email,
          patientPhone: patientInfo.phone,
          patientBirthdate: patientInfo.birthdate,
          patientGender: patientInfo.gender,
          patientReason: patientInfo.patientReason,
          patientInsuranceId: patientInfo.insuranceId,
          patientInsuranceName: patientInfo.insuranceName,
          attachments: patientInfo.attachments,
          insuranceFile: patientInfo.insuranceFile,
        };
        createAppointmentRequest(params);
        context.updateAppointment({ provider });
        history.push('/search/apt-request-confirmation');
      } catch (err) {
        console.log(err);
        enqueueSnackbar('Appointment Request Failed.');
      }
    } else {
      await onBookAppointment(patientInfo);
    }
  };

  const onBookAppointment = async (patientInformation) => {
    const { start, tenancy, updateCancelToken } = context;
    const restrictedPracticeName = await adminApi.fetchProviderDetails(
      provider.id
    );
    setProviderFamily(restrictedPracticeName.data.practiceName);
    try {
      // Check user timezone
      const currentUserTimezone =
        Intl.DateTimeFormat().resolvedOptions().timeZone;
      // Convert UTC to America/New_York time, automatically handling DST
      const estTime = DateTime.fromISO(start, {
        zone: 'UTC',
      }).setZone('America/New_York');
      const apptHour = estTime.hour;
      
      if (
        currentUserTimezone !== 'America/New_York' ||
        apptHour < 6 ||
        apptHour > 22
      ) {
        alert(
          '⚠️ Time Zone Mismatch Detected:\n' +
            'Kindly switch your system time zone to "America/New_York, EST" to proceed further.'
        );
        return;
      }
      //Check for existing appointments.
      const bookedAppt = await overBookedAppt({
        start: start,
        tenancyId: tenancy.id,
        providerId: provider.id
      }); 
      const isApptOverBooked = bookedAppt.some(obj => obj.isCurrentTimeInRange === true);
      if (!isApptOverBooked) {
        const newCancelToken = await bookAppointment({
          patient: patientInformation,
          tenancy,
          appointment: {
            attachments: images.map((i) => i.dataUrl),
            startTimestamp: start,
            patientReason: patientInformation.patientReason,
            providerId: provider.id,
          },
          insuranceFile: patientInformation.insuranceFile,
        });
        // socketIoClient.emit('message', {
        //   message: 'auto-refresh-Appointments',
        //   id: getCurrentUser && getCurrentUser.id,
        // });
        if (newCancelToken === 'No access to Book Appointment') {
          setShowProviderRestrictedModal(true);
        } else if (newCancelToken === 'Patient No access to Book Appointment') {
          setShowPatientRestrictPopUp(true);
        }
        else if(newCancelToken.msg === 'Patient already has an appointment on this day') {
          if(getCurrentUser && getCurrentUser.patient.id){
            alert(`You already have an appointment booked at Westside Family Medicine on this date (${newCancelToken.providerName}, ${newCancelToken.location}, ${newCancelToken.apptTime}).  Only one appointment per practice per day is allowed.  Please choose another day to schedule, or first cancel your other appointment and then re-attempt your booking.`);
            return;
          }
          else{
          alert("This patient already has an appointment booked at Westside Family Medicine on this date.  Only one appointment per practice per day is allowed.  Please choose another day, or cancel the other appointment and then re-attempt your booking.");
          return;
          }
          // setOpenDuplicateApptAlert(true);
        }
         else {
          updateCancelToken(newCancelToken);
          window.pageview(window.location.pathname + window.location.search);
          window.screen();
          window.conversion();
          // history.push('/search/confirmation');
          // For Google SEO analytics.
          window.location.href = 'https://wfmnyc.com/appointment-confirmation';
        }
      }
      else{
        setOpen(true)
      }
    } catch (err) {
      console.log(err);
      enqueueSnackbar('Appointment Booking Failed.');
    }
  };

  const setPropImages = (data) => {
    setImages(data);
  };

  const setPropImageFront = (data) => {
    setImageFront(data);
  };

  const setPropImageBack = (data) => {
    setImageBack(data);
  };

  const cancel = () => {
    history.goBack();
  };

  const login = () => {
    localStorage.setItem('pathRedirect', JSON.stringify(history.location));
    history.push('/login?redirect=pathRedirect');
  };

  const logout = async () => {
    try {
      await authApi.logoutUser();
      localStorage.removeItem('pathRedirect');
      localStorage.removeItem('pathUrl');
      localStorage.removeItem('info');
    } finally {
      history.push('/');
      window.location.reload();
    }
  };

  const onRestrictedClose = () => {
    setShowProviderRestrictedModal(false);
    // window.history.back();
  };

  const onRestrictedCloseForPatient = () => {
    setShowPatientRestrictPopUp(false);
  };

  const pageRedirect = ()=>{
    window.location.replace(`${process.env.REACT_APP_HOMEPAGE_URL}/specialties/search?city=&latitude=&longitude=&searchId=&searchType=`);
  }

  return (
    <>
      <CurrentUserConsumer>
        {({ currentPatient, currentUser }) => (
          <div className={container}>
            {setGetCurrentUser(currentUser)}
            {currentPatient ? (
              <div className={currentPatientNotice}>
                <h2>
                  Hi{' '}
                  {(currentPatient &&
                    currentPatient.name &&
                    currentPatient.name.charAt(0).toLowerCase()) ||
                  currentPatient.name.toUpperCase()
                    ? currentPatient.name.charAt(0).toUpperCase() +
                      currentPatient.name.slice(1)
                    : currentPatient && currentPatient.name}
                  {/* {currentPatient.name} */}!
                </h2>
                <br />
                <p>
                  Below are details about your appointment. Not{' '}
                  {currentPatient.name}? Click{' '}
                  <span onClick={logout} className={link}>
                    here to logout.
                  </span>
                </p>
              </div>
            ) : (
              <div className={currentPatientNotice}>
                <h2>Have you used Qwell before?</h2>
                <br />
                <p>
                  If so, you probably have an account. Before continuing you'll
                  need to log in. Don't worry, we'll hold your appointment for
                  you. Click{' '}
                  <span onClick={login} className={link}>
                    here to log in.
                  </span>
                </p>
              </div>
            )}

            <Dialog
              open={open}
              onClose={()=> setOpen(false)}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                An appointment has already been booked for this slot. Please choose some other available slot.
                </DialogContentText>
                <div className={btnCenter}>
                <Button
                  onClick={pageRedirect}
                  variant="contained"
                  color="primary"
                  className={button}
                >
                  Ok
                </Button>
                </div>
                
              </DialogContent>
            </Dialog>

            {/* <Dialog
              open={dupliacteApptAlert}
              onClose={()=> setOpenDuplicateApptAlert(false)}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                An appointment has already been booked for this patient on the given date. Please return to schedule and select another day to book appointment.
                </DialogContentText>
                <div className={btnCenter}>
                <Button
                  onClick={pageRedirect}
                  variant="contained"
                  color="primary"
                  className={button}
                >
                  Ok
                </Button>
                </div>
                
              </DialogContent>
            </Dialog> */}


            <Grid container spacing={8} className={containerForm}>
              <Grid item xs={12} sm={4} className={visitInfo}>
                <VisitInformation
                  isAptRequest={isAptRequest}
                  provider={provider}
                  tenancy={tenancy}
                  appointmentTime={appointmentStart}
                />
              </Grid>
              <Grid item xs={12} sm={7}>
                <PatientInformationForm
                  showProviderRestrictedModal={showProviderRestrictedModal}
                  showPatientRestrictPopUp={showPatientRestrictPopUp}
                  onRestrictedClose={onRestrictedClose}
                  onRestrictedCloseForPatient={onRestrictedCloseForPatient}
                  providerFamily={providerFamily}
                  imagesProps={images}
                  currentUserInfo={getCurrentUser}
                  setPropImages={setPropImages}
                  setPropImageBack={setPropImageBack}
                  setPropImageFront={setPropImageFront}
                  history={history}
                  location={location}
                  patient={currentPatient}
                  setCurrentPatient={changeCurrentPatient}
                  isAptRequest={isAptRequest}
                  onSubmit={onSubmit}
                  onCancel={cancel}
                  provider={provider}
                />
              </Grid>
            </Grid>
          </div>
        )}
      </CurrentUserConsumer>
    </>
  );
}

SearchCheckout.contextType = AppointmentContext;

const styles = () => ({
  container: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    alignItems: 'center',
    paddingBottom: '2em',
  },
  containerForm: {
    width: '50%',
    padding: '1rem',
    marginTop: '25px',
    '@media only screen and (max-width: 1024px)': {
      width: '100%',
      paddingTop: '0',
    },
  },
  currentPatientNotice: {
    width: '40%',
    paddingTop: '50px',
    color: 'rgba(0, 0, 0, 0.54)',
    fontSize: '1rem',
    '@media only screen and (max-width: 1024px)': {
      width: '100%',
      padding: '40px 20px',
      textAlign: 'left',
    },
  },
  link: {
    textDecoration: 'underline',
    cursor: 'pointer',
  },
  visitInfo: {
    marginRight: '25px',
    '@media only screen and (max-width: 1024px)': {
      marginRight: '0',
      marginBottom: '25px',
    },
  },
  button: {
    width: '100px',
    marginLeft: 'auto',
    marginRight: 'auto',
    marginTop: '0px',
    marginBottom: '15px',
  },
  btnCenter: {
    display: 'flex',
    alignItems: 'center'

  }
});

const styledCheckout = withStyles(styles)(SearchCheckout);

export { styledCheckout };

export default withSnackbar(withRouter(styledCheckout));
